import {useFormik} from 'formik'
import {TextInput} from '../../../../_metronic/partials'
import React, {FC, MutableRefObject} from 'react'
import {useStatusMessage} from '../../../features'
import * as Yup from 'yup'
import {Post} from '../../../../setup'
import {useMailing} from '../../../@types'
import {AxiosError} from 'axios'
import {Status} from '../../../@components'


const initialValues = {
  name: '',
  file: '',
}


const Schema = Yup.object({
  name: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(100, 'Maximum 100 symbols')
    .required('Obligatoire'),
  file: Yup.string()
    .required('Ce champ est obligatoire')
    .min(10, 'Au moins 10 lettres'),
})
const isAxiosError = (error: any): error is AxiosError => {
  return (error as AxiosError).isAxiosError !== undefined
}


const INSERT_LIST = process.env.REACT_APP_MAILING_LISTS_CONTACTS_INSERT_CREATE || 'v2/list-contact-insert'
const stringBefore = "email,first_name,last_name\n";

interface InsertListInterface {
  closeRef: MutableRefObject<HTMLButtonElement | null>
}

const InsertList: FC<InsertListInterface> = ({closeRef}) => {

  const {formState, setLoading, handleStatusMessage} = useStatusMessage()
  const {triggerReload} = useMailing()

  const onSubmit = async (values: typeof initialValues, {setSubmitting}: {
    setSubmitting: (isSubmitting: boolean) => void
  }) => {

    setLoading(true)

    try {
      const formValues = {...values, file: stringBefore + values.file}

      const {data} = await Post<any>(INSERT_LIST, formValues)
      if (data) {
        handleStatusMessage({
          status: 200,
          message: 'Votre liste a été ajoutée avec succès.',
          color: 'success',
          icon: '/general/gen048.svg',
        })
        triggerReload()
        setTimeout(() => {
          closeRef.current?.click()
        }, 2600)
      }

    } catch (err) {
      if (isAxiosError(err)) {
        const {name} = err.response?.data.errors
        if (name.length) {
          handleStatusMessage({
            status: 400,
            message: 'Le nom de la liste fournie existe déjà.',
            color: 'danger',
            icon: '/general/gen050.svg',
          })
        }
      }
    } finally {
      setLoading(false)
      setSubmitting(false)
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema: Schema,
    enableReinitialize: true,
    onSubmit,
  })

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-6">
            <TextInput formik={formik} name={'name'} label={'Nom'} flex={'row'} />
          </div>
          <div className="col-12">
            <textarea className="form-control form-control-solid mb-3"
                      rows={4}
                      placeholder="E-mail, Nom, Prénom"
                      {...formik.getFieldProps('file')}
            />
          </div>
          <div className="col-12">
            <Status {...formState.statusMessage} />
          </div>
        </div>
        <div className="text-end mt-5">
          <button type="submit" className="btn btn-sm btn-primary me-2 px-6" disabled={formState.loading}>
            {formState.loading ? (
              <span className="indicator-progress d-block">
                  S'il vous plaît, attendez... <span
                className="spinner-border spinner-border-sm align-middle ms-2" />
                </span>
            ) : (
              'Sauvegarder'
            )}
          </button>
          <button type="button"
                  className="btn btn-sm btn-light me-2 px-6"
                  data-bs-dismiss="modal"
                  onClick={() => formik.resetForm()}
                  ref={closeRef}
          >
            Fermer
          </button>
        </div>
      </form>
    </>
  )
}

export {InsertList}